module.exports = __webpack_public_path__ + "static/img/fz_rz.2faf6ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_rz.png
// module id = XaYU
// module chunks = 0